import { unwrapResult } from '@reduxjs/toolkit'
import { Col, DatePicker, Form, Modal, notification, Row } from 'antd'
import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { RootDispatch } from '../../app/store'
import { EditableList } from '../../compnents/list/EditableList'
import { AcceptanceModalColumns } from './columns'
import {
  getAcceptanceModalListAsync,
  getSubmitAcceptanceAsync,
} from './putstorelistSlice'
import styles from './Putstorelist.module.css'
import { getBuildOtherRecipeAsync } from '../chainTransferApplication/chainSlice'
import form from 'antd/lib/form'
import moment from 'moment'
import { DateTimeFormat, DateTimeFormatSimple } from '../../models/datetime'

export const AcceptanceModalVisible = (props: {
  data?: any
  tenantInventoryReceiptsId?: any
  visible?: any
  onOk: () => void
  onCancel: (v?:any) => void
}) => {
  const [form] = Form.useForm()

  const dispatch = useDispatch<RootDispatch>()

  const [params, setParams] = useState<any>({
    current: 1,
    size: 10,
  })

  const [paramList, setParamList] = useState<any>()

  const [pages, setPage] = useState<any>({
    items: [],
    total: 0,
  })

  const [pageLoading, setPageLoading] = useState(false)

  const handleChange = (prev: any, next: any) => {
    const newData: any = {
      ...prev,
      ...next,
    }

    const list = pages?.items?.map((v: any) => {
      return v?.id == newData?.id ? { ...v, ...newData } : v
    })

    setParamList(list)
    setPage({ items: list, total: 0 })
  }

  useEffect(() => {
    if (props?.visible) {
      setPageLoading(true)
      dispatch(getAcceptanceModalListAsync(props?.tenantInventoryReceiptsId))
        .then(unwrapResult)
        .then((res?: any) => {
          const data = res.outInvReceiptsItemList?.map((v: any) => {
            return {
              ...v,
              recepitsDate: res?.inventoryReceipts?.recepitsDate,
              bhgCount: 0,
              remark: '',
              acceptanceConclusion: '验收合格',
              qualityStatus: '产品完好无损',
            }
          })
          setPage({
            items: data,
            total: 0,
          })
          setParamList(data)
          form.setFieldsValue({
            procurementDate:moment(res?.inventoryReceipts?.recepitsDate).subtract(1, 'day').startOf('day'),
            arrivalDate:moment(res?.inventoryReceipts?.recepitsDate)
          })
        })
        .finally(() => setPageLoading(false))
    } else {
      setPage({
        items: [],
        total: 0,
      })
    }
  }, [props?.visible])

  return (
    <Modal
      className={styles.modalStyle}
      width={1100}
      title={'生成验收单'}
      visible={props?.visible}
      onOk={() => {
        form.validateFields().then((values) => {
          const data = {
          inventoryReceiptsId: props.data?.id,
          supplierId: props.data?.supplierId,
          supplierName: props.data?.supplierName?.replace(/[<>]/g, ''),
          type: 4,
          upaccountFlag: false,
          approvedFlag: false,
          arrivalDate: form.getFieldValue('arrivalDate')
          ? moment(form.getFieldValue('arrivalDate')).format(DateTimeFormat)
          : "",
          procurementDate:  form.getFieldValue('procurementDate')
          ? moment(form.getFieldValue('procurementDate')).format(DateTimeFormat)
          : "",
          inventoryPurchaseAcceptanceBatchDTOList: paramList?.map((v: any) => {
            return {
              ...v,
              id: null,
              tenantInventoryReceiptsItemId: props?.tenantInventoryReceiptsId,
              supplierName: v?.tenantSupplierName?.replace(/[<>]/g, ''),
              supplierId: v?.tenantSupplierId,
              totalQuantity: v?.count,
              qualifiedQuantity: v?.count,
              totalReceiptAmount: v?.count * v?.unitPrice,
              arrivalUnitPrice: v?.unitPrice,
              tenantSupplierName: v?.tenantSupplierName?.replace(/[<>]/g, ''),
              productInfo: v.productInfo?.replace(/[<>]/g, ''),
            }
          }),
          }
          dispatch(getBuildOtherRecipeAsync(data))
            .then(unwrapResult)
            .then(() => {
              props?.onOk()
            })
            .catch((v) => {
              props?.onCancel(v?.message)
            })
        })
      }}
      onCancel={() => {
        props?.onCancel()
      }}
    >
      <Form
        form={form}
        name='control-hooks'
        autoComplete='off'
        colon={false}
        labelCol={{ span: 7 }}
      >
        <Row gutter={20}>
          <Col span={6}>
            <Form.Item
              name='procurementDate'
              label='采购日期'
              rules={[{ required: true, message: '采购日期不能为空' }]}
            >
              <DatePicker
                format={DateTimeFormatSimple}
                allowClear
                style={{ width: '100%' }}
              />
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item
              name='arrivalDate'
              label='到货日期'
              rules={[{ required: true, message: '到货日期不能为空' }]}
            >
              <DatePicker
                format={DateTimeFormatSimple}
                allowClear
                style={{ width: '100%' }}
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>
      <EditableList
        pagination={false}
        style={{ height: '480px' }}
        loading={pageLoading}
        page={{
          items: pages?.items,
          current: 1,
          size: 10,
          total: 0,
        }}
        rowKey={(v, i) => `${i}`}
        columns={AcceptanceModalColumns((t) => {
          handleChange(t.prev, t.next)
        }, params?.size * (params?.current - 1))}
        onChangePage={(current, size) =>
          setParams({
            ...params,
            current,
            size: size || 10,
          })
        }
      ></EditableList>
    </Modal>
  )
}
